module.exports = __webpack_public_path__ + "img/2.d436c0ff.png";